module.exports = __webpack_public_path__ + "img/flower_leaf_26.40158c4b.png";